const PATH = '/node_modules/@tcc-online/assets/icons';
const ICONS = import.meta.glob('/node_modules/@tcc-online/assets/icons/*.svg');

export default async function loadIconAsset(iconName: string) {
    let loadedIcon = null;

    if (ICONS[`${PATH}/${iconName}`]) {
        const iconModule = ICONS[`${PATH}/${iconName}`];

        loadedIcon = (await iconModule()) as any;
    }

    return loadedIcon;
}
